import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: '100%',
      position: 'relative',
      margin: theme.spacing(1),
      minHeight: '35vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      fontSize: 80,
      color: theme.palette.grey[500],
    },
    title: {
      color: theme.palette.text.hint,
      fontWeight: 400,
      marginBottom: theme.spacing(2),
    },
    subTitle: {
      color: theme.palette.text.hint,
    },
    noDataIconWrapper: {
      width: 85,
      height: 85,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.grey[200],
      borderRadius: '50%',
      userSelect: 'none',
      marginBottom: theme.spacing(3.5),
    },
    noDataIcon: {
      color: '#f7f7f7',
      fontSize: 36,
      transform: 'translate(2px, 2px)',
      userSelect: 'none',
    },
  }),
);
